
window.lazySizesConfig = window.lazySizesConfig || {};

// in case you want to use custom media query aliases in your markup, instead of full media queries
window.lazySizesConfig.customMedia = {
  '--xs': '(max-width: 767px)',
  '--sm': '(max-width: 1023px)',
  '--md': '(max-width: 1919px)',
  '--lg': '(max-width: 10000px)',
  '--xl': '(max-width: 10000px)',
};
